import { AbstractControl, FormControl, FormGroup } from "@angular/forms";
import { affiliateTypeImmutable } from "../util/affiliateType";
import { companyClassificationListx } from "../util/classificationList";

export class Utility {

  static validateAllFormFields(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(field => {
      const control: AbstractControl | null = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  static isObjEmpty(obj): boolean {
    return Object.keys(obj).length === 0;
  }

  static transformAffiliate(affiliate: any) {
    if (typeof affiliate.affiliateTypeFk === "object") {
      if (typeof affiliate.affiliateTypeFk?.id) {
        affiliate['affiliateTypeFk'] = affiliate['affiliateTypeFk']?.id;
      } else {
        affiliate['affiliateTypeFk'] = null;
      }
    }

    if (typeof affiliate.countryFk === "object") {
      if (typeof affiliate.countryFk?.id) {
        affiliate['countryFk'] = affiliate['countryFk']?.id;
      } else {
        affiliate['countryFk'] = null;
      }
    }

    if (affiliate['corporationCompany']?.id) {
      affiliate['corporationCompany'] = affiliate['corporationCompany']?.id;
    } else {
      affiliate['corporationCompany'] = null;
    }

    return affiliate;
  }

  static affiliateTransformToSetAffiliateType(affiliates: any[]): any[] {
    const affiliateList = JSON.parse(JSON.stringify(affiliates));
    let i = 0;
    for(let affiliate of affiliateList) {
      affiliateList[i]['affiliateTypeFk'] = Utility.getAffiliateType(affiliate?.affiliateTypeFk);
      i++
    }
    return affiliateList;
  }

  static getAffiliateType(affiliateTypeId: number): any {
    const result = affiliateTypeImmutable.filter(affiliateType => {
      return affiliateType.id == affiliateTypeId;
    });
    if(result.length > 0) {
      return result[0]
    }
    return null;
  }

  static getClassification(classificationId: number): any {
    const list = companyClassificationListx.filter(r => {
      return r.id == classificationId;
    });

    if(list.length > 0) {
      return list[0];
    }
  }

  static getClassificationId(company: any): number {
    if(company?.classification?.id) {
      return company?.classification?.id;
    } else if(company?.classificationFk) {
      return company?.classificationFk;
    }
    return company?.classificationId;
  }

}
